/**
 * ict.js — 지능형SW대학 이수요건 데이터
 * 출처: 2026학년도 전공 교육과정 (2026_major.pdf)
 */

export const ICT_REQUIREMENTS = [

  // ── 컴퓨터공학부 / 2026학번 / 1학년 1학기 ────────────────────────────────────
  {
    id:             'cs_2026_1_1',
    collegeId:      'it',
    collegeName:    '지능형SW대학',
    departmentId:   'cs',
    departmentName: '컴퓨터공학부',
    majorId:        'cs_main',
    majorName:      '컴퓨터공학전공',
    admissionYear:  2026,
    grade:          1,
    semester:       1,
    status:         'official',
    requiredCourses: [
      { courseName: '수학1',           courseCode: '03747', type: '기초교양', credits: 3, required: true, matchKeywords: ['수학1'] },
      { courseName: 'C언어',           courseCode: '09970', type: '기초교양', credits: 3, required: true, matchKeywords: ['C언어'] },
    ],
    recommendedCourses: [],
    graduationRules: { totalCredits: 130, majorRequiredCredits: null, majorElectiveCredits: null, liberalArtsCredits: null },
    notes: ['2026학년도 전공 교육과정 기준 공식 데이터'],
  },

  // ── 컴퓨터공학부 / 2026학번 / 1학년 2학기 ────────────────────────────────────
  {
    id:             'cs_2026_1_2',
    collegeId:      'it',
    collegeName:    '지능형SW대학',
    departmentId:   'cs',
    departmentName: '컴퓨터공학부',
    majorId:        'cs_main',
    majorName:      '컴퓨터공학전공',
    admissionYear:  2026,
    grade:          1,
    semester:       2,
    status:         'official',
    requiredCourses: [
      { courseName: '소프트웨어적사고', courseCode: '10606', type: '기초교양', credits: 3, required: true, matchKeywords: ['소프트웨어적사고'] },
      { courseName: '디지털논리설계',   courseCode: '02053', type: '전공필수', credits: 3, required: true, matchKeywords: ['디지털논리설계'] },
    ],
    recommendedCourses: [],
    graduationRules: { totalCredits: 130, majorRequiredCredits: null, majorElectiveCredits: null, liberalArtsCredits: null },
    notes: ['2026학년도 전공 교육과정 기준 공식 데이터'],
  },

  // ── 컴퓨터공학부 / 2025학번 / 2학년 1학기 ────────────────────────────────────
  {
    id:             'cs_2025_2_1',
    collegeId:      'it',
    collegeName:    '지능형SW대학',
    departmentId:   'cs',
    departmentName: '컴퓨터공학부',
    majorId:        'cs_main',
    majorName:      '컴퓨터공학전공',
    admissionYear:  2025,
    grade:          2,
    semester:       1,
    status:         'official',
    requiredCourses: [
      { courseName: '데이터구조',   courseCode: '01760', type: '전공필수', credits: 3, required: true, matchKeywords: ['데이터구조'] },
      { courseName: '인공지능기초', courseCode: '12796', type: '전공필수', credits: 3, required: true, matchKeywords: ['인공지능기초'] },
    ],
    recommendedCourses: [],
    graduationRules: { totalCredits: 130, majorRequiredCredits: null, majorElectiveCredits: null, liberalArtsCredits: null },
    notes: ['2026학년도 전공 교육과정 기준 공식 데이터'],
  },

  // ── AI·소프트웨어학부 / 2026학번 / 1학년 1학기 ───────────────────────────────
  {
    id:             'ai_sw_2026_1_1',
    collegeId:      'it',
    collegeName:    '지능형SW대학',
    departmentId:   'ai_sw',
    departmentName: 'AI·소프트웨어학부',
    majorId:        'ai_sw_main',
    majorName:      'AI소프트웨어전공',
    admissionYear:  2026,
    grade:          1,
    semester:       1,
    status:         'official',
    requiredCourses: [
      { courseName: '수학1',           courseCode: '03747', type: '기초교양', credits: 3, required: true, matchKeywords: ['수학1'] },
      { courseName: '소프트웨어적사고', courseCode: '10606', type: '기초교양', credits: 3, required: true, matchKeywords: ['소프트웨어적사고'] },
      { courseName: '통계학1',         courseCode: '09969', type: '전공필수', credits: 3, required: true, matchKeywords: ['통계학1'] },
    ],
    recommendedCourses: [],
    graduationRules: { totalCredits: 130, majorRequiredCredits: null, majorElectiveCredits: null, liberalArtsCredits: null },
    notes: ['2026학년도 전공 교육과정 기준 공식 데이터 (AI데이터과학부 기준)'],
  },

  // ── AI·소프트웨어학부 / 2026학번 / 1학년 2학기 ───────────────────────────────
  {
    id:             'ai_sw_2026_1_2',
    collegeId:      'it',
    collegeName:    '지능형SW대학',
    departmentId:   'ai_sw',
    departmentName: 'AI·소프트웨어학부',
    majorId:        'ai_sw_main',
    majorName:      'AI소프트웨어전공',
    admissionYear:  2026,
    grade:          1,
    semester:       2,
    status:         'official',
    requiredCourses: [
      { courseName: '수학2',   courseCode: '03751', type: '기초교양', credits: 3, required: true, matchKeywords: ['수학2'] },
      { courseName: '통계학2', courseCode: '09971', type: '전공필수', credits: 3, required: true, matchKeywords: ['통계학2'] },
      { courseName: 'AI기초',  courseCode: '12641', type: '전공필수', credits: 3, required: true, matchKeywords: ['AI기초'] },
    ],
    recommendedCourses: [],
    graduationRules: { totalCredits: 130, majorRequiredCredits: null, majorElectiveCredits: null, liberalArtsCredits: null },
    notes: ['2026학년도 전공 교육과정 기준 공식 데이터'],
  },

  // ── AI·소프트웨어학부 / 2025학번 / 2학년 1학기 ───────────────────────────────
  {
    id:             'ai_sw_2025_2_1',
    collegeId:      'it',
    collegeName:    '지능형SW대학',
    departmentId:   'ai_sw',
    departmentName: 'AI·소프트웨어학부',
    majorId:        'ai_sw_main',
    majorName:      'AI소프트웨어전공',
    admissionYear:  2025,
    grade:          2,
    semester:       1,
    status:         'official',
    requiredCourses: [
      { courseName: '데이터구조', courseCode: '01760', type: '전공필수', credits: 3, required: true, matchKeywords: ['데이터구조'] },
      { courseName: '머신러닝1',  courseCode: '10977', type: '전공필수', credits: 3, required: true, matchKeywords: ['머신러닝1'] },
    ],
    recommendedCourses: [],
    graduationRules: { totalCredits: 130, majorRequiredCredits: null, majorElectiveCredits: null, liberalArtsCredits: null },
    notes: ['2026학년도 전공 교육과정 기준 공식 데이터'],
  },
]
